import styled from '@emotion/styled';
import { Link as RouterLink } from 'react-router-dom';
import setMargin from '../../helpers/set-margin';

const weights = {
  bold: 'bold !important',
  regular: 'normal !important'
};

const fontSizes = {
  f80: '80px !important',
  f48: '48px !important',
  f40: '40px !important',
  f36: '36px !important',
  f32: '32px !important',
  f30: '30px !important',
  f28: '28px !important',
  f24: '24px !important',
  f20: '20px !important',
  f18: '18px !important',
  f16: '16px !important',
  f14: '14px !important'
};

const lineHeights = {
  extraLarge: '120% !important',
  larger: '120% !important',
  large: '120% !important',
  medLarge: '120% !important',
  med: '120% !important',
  regular: '150% !important',
  small: '150% !important'
};

const commonStyle = () => `
  font-style: normal !important;
  letter-spacing: 0.2px !important;
  font-family: 'nunito-sans';

`;

const Heading1 = styled('h1')`
  ${setMargin};
  ${commonStyle};
  font-family: 'antonio', 'Arial Narrow', Arial, sans-serif !important;
  color: ${({ color, theme }) =>
    color ? color : theme.colors.neutral.shades.shade700};
  font-size: ${({ size }) => (size ? fontSizes[size] : fontSizes.f48)};
  line-height: ${({ size }) => (size ? lineHeights[size] : '56px !important')};
  font-weight: ${({ weight }) => (weight ? weights[weight] : '800 !important')};
  letter-spacing: ${({ letterSpacing }) =>
    letterSpacing || '-0.02em !important'};
  text-transform: ${({ textTransform }) => textTransform || 'none !important'};
  text-align: ${({ ta }) => ta || 'left !important'};
`;
export const H1 = (props: any) => <Heading1 {...props} />;

const Heading2 = styled('h2')`
  ${setMargin};
  ${commonStyle};
  font-family: 'antonio', 'Arial Narrow', Arial, sans-serif !important;
  color: ${({ color, theme }) =>
    color ? color : theme.colors.neutral.shades.shade700};
  font-size: ${({ size }) => (size ? fontSizes[size] : fontSizes.f36)};
  line-height: ${({ size }) => (size ? lineHeights[size] : '56px !important')};
  font-weight: ${({ weight }) => (weight ? weights[weight] : '800 !important')};
  letter-spacing: ${({ letterSpacing }) =>
    letterSpacing || '-0.02em !important'};
  text-transform: ${({ textTransform }) => textTransform || 'none !important'};
  text-align: ${({ ta }) => ta || 'left !important'};
`;
export const H2 = (props: any) => <Heading2 {...props} />;

const Heading3 = styled('h3')`
  ${setMargin};
  ${commonStyle};
  font-family: 'antonio', 'Arial Narrow', Arial, sans-serif !important;
  color: ${({ color, theme }) =>
    color ? color : theme.colors.neutral.shades.shade700};
  font-size: ${({ size }) => (size ? fontSizes[size] : fontSizes.f32)};
  line-height: ${({ size }) => (size ? lineHeights[size] : '40px !important')};
  font-weight: ${({ weight }) => (weight ? weights[weight] : '800 !important')};
  letter-spacing: ${({ letterSpacing }) =>
    letterSpacing || '-0.02em !important'};
  text-transform: ${({ textTransform }) => textTransform || 'none !important'};
  text-align: ${({ ta }) => ta || 'left !important'};
`;
export const H3 = (props: any) => <Heading3 {...props} />;

const Heading4 = styled('h4')`
  ${setMargin};
  ${commonStyle};
  font-family: 'antonio', 'Arial Narrow', Arial, sans-serif !important;
  color: ${({ color, theme }) =>
    color ? color : theme.colors.neutral.shades.shade700};
  font-size: ${({ size }) => (size ? fontSizes[size] : fontSizes.f24)};
  line-height: ${({ size }) => (size ? lineHeights[size] : '32px !important')};
  font-weight: ${({ weight }) => (weight ? weights[weight] : '800 !important')};
  letter-spacing: ${({ letterSpacing }) =>
    letterSpacing || '-0.02em !important'};
  text-transform: ${({ textTransform }) => textTransform || 'none !important'};
  text-align: ${({ ta }) => ta || 'left !important'};
`;
export const H4 = (props: any) => <Heading4 {...props} />;

const Heading5 = styled('h5')`
  ${setMargin};
  ${commonStyle};
  color: ${({ color, theme }) =>
    color ? color : theme.colors.neutral.shades.shade700};
  font-size: ${({ size }) => (size ? fontSizes[size] : fontSizes.f20)};
  line-height: ${({ size }) => (size ? lineHeights[size] : '28px !important')};
  font-weight: ${({ weight }) => (weight ? weights[weight] : '800 !important')};
  letter-spacing: ${({ letterSpacing }) =>
    letterSpacing || '-0.02em !important'};
  text-transform: ${({ textTransform }) => textTransform || 'none !important'};
  text-align: ${({ ta }) => ta || 'left !important'};
`;
export const H5 = (props: any) => <Heading5 {...props} />;

const Heading18px = styled('h6')`
  ${setMargin};
  ${commonStyle};
  color: ${({ color, theme }) =>
    color ? color : theme.colors.neutral.shades.shade700};
  font-size: ${({ size }) => (size ? fontSizes[size] : fontSizes.f18)};
  line-height: ${({ size }) => (size ? lineHeights[size] : '24px !important')};
  font-weight: ${({ weight }) => (weight ? weights[weight] : '800 !important')};
  letter-spacing: ${({ letterSpacing }) =>
    letterSpacing || '-0.02em !important'};
  text-transform: ${({ textTransform }) => textTransform || 'none !important'};
  text-align: ${({ ta }) => ta || 'left !important'};
`;
export const H18px = (props: any) => <Heading18px {...props} />;

const Heading16px = styled('h6')`
  ${setMargin};
  ${commonStyle};
  color: ${({ color, theme }) =>
    color ? color : theme.colors.neutral.shades.shade700};
  font-size: ${({ size }) => (size ? fontSizes[size] : fontSizes.f18)};
  line-height: ${({ size }) => (size ? lineHeights[size] : '24px !important')};
  font-weight: ${({ weight }) => (weight ? weights[weight] : '800 !important')};
  letter-spacing: ${({ letterSpacing }) =>
    letterSpacing || '-0.02em !important'};
  text-transform: ${({ textTransform }) => textTransform || 'none !important'};
  text-align: ${({ ta }) => ta || 'left !important'};
`;
export const H16px = (props: any) => <Heading16px {...props} />;

const HeadingCaps = styled('h6')`
  ${setMargin};
  ${commonStyle};
  color: ${({ color, theme }) =>
    color ? color : theme.colors.neutral.shades.shade700};
  font-size: ${({ size }) => (size ? fontSizes[size] : fontSizes.f16)};
  line-height: ${({ size }) => (size ? lineHeights[size] : '24px !important')};
  font-weight: ${({ weight }) => (weight ? weights[weight] : '800 !important')};
  letter-spacing: ${({ letterSpacing }) =>
    letterSpacing || '0.06em !important'};
  text-transform: ${({ textTransform }) =>
    textTransform || 'uppercase !important'};
  text-align: ${({ ta }) => ta || 'left !important'};
`;
export const HCaps = (props: any) => <HeadingCaps {...props} />;

const HeadingSmallCaps = styled('h6')`
  ${setMargin};
  ${commonStyle};
  color: ${({ color, theme }) =>
    color ? color : theme.colors.neutral.shades.shade700};
  font-size: ${({ size }) => (size ? fontSizes[size] : fontSizes.f14)};
  line-height: ${({ size }) => (size ? lineHeights[size] : '20px !important')};
  font-weight: ${({ weight }) => (weight ? weights[weight] : '800 !important')};
  letter-spacing: ${({ letterSpacing }) =>
    letterSpacing || '0.06em !important'};
  text-transform: ${({ textTransform }) =>
    textTransform || 'uppercase !important'};
  text-align: ${({ ta }) => ta || 'left !important'};
`;
export const HSmallCaps = (props: any) => <HeadingSmallCaps {...props} />;

const LargeBold = styled('p')`
  ${setMargin};
  ${commonStyle};
  color: ${({ color, theme }) =>
    color ? color : theme.colors.neutral.shades.shade700};
  font-size: ${({ size }) => (size ? fontSizes[size] : fontSizes.f24)};
  line-height: ${({ size }) => (size ? lineHeights[size] : '32px !important')};
  font-weight: ${({ weight }) => (weight ? weights[weight] : '800 !important')};
  text-transform: ${({ textTransform }) => textTransform || 'none !important'};
  text-align: ${({ ta }) => ta || 'left !important'};
`;
export const TextLargeBold = (props: any) => <LargeBold {...props} />;

const LargeRegular = styled('p')`
  ${setMargin};
  ${commonStyle};
  color: ${({ color, theme }) =>
    color ? color : theme.colors.neutral.shades.shade700};
  font-size: ${({ size }) => (size ? fontSizes[size] : fontSizes.f24)};
  line-height: ${({ size }) => (size ? lineHeights[size] : '32px !important')};
  font-weight: ${({ weight }) => (weight ? weights[weight] : '400 !important')};
  text-transform: ${({ textTransform }) => textTransform || 'none !important'};
  text-align: ${({ ta }) => ta || 'left !important'};
`;
export const TextLargeRegular = (props: any) => <LargeRegular {...props} />;

const MediumBold = styled('p')`
  ${setMargin};
  ${commonStyle};
  color: ${({ color, theme }) =>
    color ? color : theme.colors.neutral.shades.shade700};
  font-size: ${({ size }) => (size ? fontSizes[size] : fontSizes.f18)};
  line-height: ${({ size }) => (size ? lineHeights[size] : '24px !important')};
  font-weight: ${({ weight }) => (weight ? weights[weight] : '800 !important')};
  text-transform: ${({ textTransform }) => textTransform || 'none !important'};
  text-align: ${({ ta }) => ta || 'left !important'};
`;
export const TextMediumBold = (props: any) => <MediumBold {...props} />;

const MediumRegular = styled('p')`
  ${setMargin};
  ${commonStyle};
  color: ${({ color, theme }) =>
    color ? color : theme.colors.neutral.shades.shade700};
  font-size: ${({ size }) => (size ? fontSizes[size] : fontSizes.f18)};
  line-height: ${({ size }) => (size ? lineHeights[size] : '24px !important')};
  font-weight: ${({ weight }) => (weight ? weights[weight] : '400 !important')};
  text-transform: ${({ textTransform }) => textTransform || 'none !important'};
  text-align: ${({ ta }) => ta || 'left !important'};
`;
export const TextMediumRegular = (props: any) => <MediumRegular {...props} />;

const SmallBold = styled('p')`
  ${setMargin};
  ${commonStyle};
  color: ${({ color, theme }) =>
    color ? color : theme.colors.neutral.shades.shade700};
  font-size: ${({ size }) => (size ? fontSizes[size] : fontSizes.f16)};
  line-height: ${({ size }) => (size ? lineHeights[size] : '24px !important')};
  font-weight: ${({ weight }) => (weight ? weights[weight] : '800 !important')};
  text-transform: ${({ textTransform }) => textTransform || 'none !important'};
  text-align: ${({ ta }) => ta || 'left !important'};
`;
export const TextSmallBold = (props: any) => <SmallBold {...props} />;

const SmallRegular = styled('p')`
  ${setMargin};
  ${commonStyle};
  color: ${({ color, theme }) =>
    color ? color : theme.colors.neutral.shades.shade700};
  font-size: ${({ size }) => (size ? fontSizes[size] : fontSizes.f16)};
  line-height: ${({ size }) => (size ? lineHeights[size] : '24px !important')};
  font-weight: ${({ weight }) => (weight ? weights[weight] : '400 !important')};
  text-transform: ${({ textTransform }) => textTransform || 'none !important'};
  text-align: ${({ ta }) => ta || 'left !important'};
`;
export const TextSmallRegular = (props: any) => <SmallRegular {...props} />;

const ExtraSmallBold = styled('p')`
  ${setMargin};
  ${commonStyle};
  color: ${({ color, theme }) =>
    color ? color : theme.colors.neutral.shades.shade700};
  font-size: ${({ size }) => (size ? fontSizes[size] : fontSizes.f14)};
  line-height: ${({ size }) => (size ? lineHeights[size] : '24px !important')};
  font-weight: ${({ weight }) => (weight ? weights[weight] : '800 !important')};
  text-transform: ${({ textTransform }) => textTransform || 'none !important'};
  text-align: ${({ ta }) => ta || 'left !important'};
`;
export const TextExtraSmallBold = (props: any) => <ExtraSmallBold {...props} />;

const ExtraSmallRegular = styled('p')`
  ${setMargin};
  ${commonStyle};
  color: ${({ color, theme }) =>
    color ? color : theme.colors.neutral.shades.shade700};
  font-size: ${({ size }) => (size ? fontSizes[size] : fontSizes.f14)};
  line-height: ${({ size }) => (size ? lineHeights[size] : '24px !important')};
  font-weight: ${({ weight }) => (weight ? weights[weight] : '400 !important')};
  text-transform: ${({ textTransform }) => textTransform || 'none !important'};
  text-align: ${({ ta }) => ta || 'left !important'};
`;
export const TextExtraSmallRegular = (props: any) => (
  <ExtraSmallRegular {...props} />
);

const LinkBase = ({
  to,
  external = false,
  underline,
  ...props
}: {
  to: any;
  external?: boolean;
  underline: any;
}) => {
  return external ? (
    <a target="_blank" href={to} rel="noreferrer" {...props}>
      {props.children}
    </a>
  ) : (
    <RouterLink to={to} {...props}>
      {props.children}
    </RouterLink>
  );
};

const Anchor = styled(LinkBase)`
  ${setMargin};
  ${commonStyle};
  color: ${({ color, theme }) =>
    color ? color : theme.colors.neutral.shades.shade700};
  font-size: ${({ size }) => (size ? fontSizes[size] : fontSizes.f16)};
  line-height: ${({ size }) => (size ? lineHeights[size] : '24px !important')};
  font-weight: ${({ weight }) => (weight ? weights[weight] : '400 !important')};
  text-transform: ${({ textTransform }) => textTransform || 'none !important'};
  text-align: ${({ ta }) => ta || 'left !important'};
  text-decoration-line: ${({ decoration }) =>
    decoration || 'underline !important'};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  /* clicking style */
  :active {
    color: ${({ variant, theme, disabled }) =>
    decideColorActive({ variant, theme, disabled })};
  }

  :hover {
    color: ${({ variant, theme, disabled }) =>
    decideColorHover(variant, theme, disabled)};
  }

  :focus {
    box-shadow: 0px 0px 0px 2px #B2F2F9;
    border-radius: 4px;
  }
  :focus-visible {
    outline: none;
  }
`;
export const Link = (props: any) => <Anchor {...props} />;

export const decideColorBasic = ({ variant, disabled, theme }) => {
  if (disabled) {
    return `${theme.colors.neutral.shades.shade300}`;
  } else {
    switch (variant) {
      case 'primary':
        return `${theme.colors.primary.shades.shade900}`;
      case 'secondary':
        return `${theme.colors.secondary.shades.shade700}`;
      case 'blue':
        return `${theme.colors.blue.shades.shade700}`;
      default:
        return `${theme.colors.primary.shades.shade900}`;
    }
  }
};

export const decideColorActive = ({ variant, theme, disabled }) => {
  if (disabled) {
    return `${theme.colors.neutral.shade300}`;
  } else {
    switch (variant) {
      case 'primary':
        return `${theme.colors.primary.shades.shade700}`;
      case 'secondary':
        return `${theme.colors.secondary.shades.shade500}`;
      case 'blue':
        return `${theme.colors.blue.shades.shade500}`;
      default:
        return `${theme.colors.primary.shades.shade700}`;
    }
  }
};

export const decideColorHover = (variant = 'primary', theme, disabled) => {
  if (disabled) {
    return `${theme.colors.neutral.shade300}`;
  } else {
    switch (variant) {
      case 'primary':
        return `${theme.colors.primary.shades.shade800}`;
      case 'secondary':
        return `${theme.colors.secondary.shades.shade600}`;
      case 'blue':
        return `${theme.colors.blue.shades.shade600}`;
      default:
        return `${theme.colors.blue.shades.shade300}`;
    }
  }
};
